import { useState } from "react";
import DifferenceOutlinedIcon from "@mui/icons-material/DifferenceOutlined";
import supabase from "../../api/supabase"; // Import your Supabase client
import toast from "react-hot-toast"; // Import toast for notifications
import "./ResetHistoryButton.scss"; // Import SCSS file for styling

const ResetHistoryButton = () => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleReset = async () => {
    setIsProcessing(true);

    try {
      // Fetch the first row from taskManager to get the earliest date
      const { data: firstTask, error: firstTaskError } = await supabase
        .from("taskManager")
        .select("checkinTime")
        .order("checkinTime", { ascending: true })
        .limit(1)
        .single();

      if (firstTaskError || !firstTask) {
        throw new Error("Could not fetch the first task from taskManager");
      }

      // Extract the local date part (YYYY-MM-DD) from checkinTime
      const originalDate = new Date(firstTask.checkinTime);
      const year = originalDate.getFullYear();
      const month = String(originalDate.getMonth() + 1).padStart(2, "0");
      const day = String(originalDate.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;

      console.log("Date only original (local): ", date);

      // Fetch records from taskManager_history with the same "checkinTime"
      const { data: historyRecords, error: historyError } = await supabase
        .from("taskManager_history")
        .select("checkinTime")
        .gte("checkinTime", `${date}T00:00:00`)
        .lte("checkinTime", `${date}T23:59:59`);

      if (historyError) {
        throw new Error("Could not fetch records from taskManager_history");
      }

      // If records exist, delete them
      if (historyRecords && historyRecords.length > 0) {
        const { error: deleteError } = await supabase
          .from("taskManager_history")
          .delete()
          .gte("checkinTime", `${date}T00:00:00`)
          .lte("checkinTime", `${date}T23:59:59`);

        if (deleteError) {
          throw new Error("Could not delete records from taskManager_history");
        }
        console.log("Deleted existing records for the date:", date);
      }

      // Fetch all tasks from taskManager and order by "id"
      const { data: tasks, error: fetchTasksError } = await supabase
        .from("taskManager")
        .select("*")
        .order("id", { ascending: true });

      if (fetchTasksError || !tasks) {
        throw new Error("Could not fetch tasks from taskManager");
      }

      // Modify tasks to remove 'id' and contain only the local date part in checkinTime
      const tasksWithoutId = tasks.map((task) => {
        const { checkinTime, id, ...rest } = task;
        const taskDate = new Date(checkinTime);
        const taskYear = taskDate.getFullYear();
        const taskMonth = String(taskDate.getMonth() + 1).padStart(2, "0");
        const taskDay = String(taskDate.getDate()).padStart(2, "0");
        const dateOnly = `${taskYear}-${taskMonth}-${taskDay}`;
        console.log("Id removed:", id);
        return {
          ...rest, // Include all properties except 'id'
          checkinTime: dateOnly, // Store only the date part in checkinTime
        };
      });

      if (tasksWithoutId.length === 0) {
        throw new Error("No tasks available to copy to History Records.");
      }

      // Log the data being inserted
      console.log(
        "Data being inserted into taskManager_history:",
        tasksWithoutId
      );

      // Insert tasks into taskManager_history
      const { error: insertError } = await supabase
        .from("taskManager_history")
        .insert(tasksWithoutId);

      if (insertError) {
        console.error("Detailed insert error:", insertError);
        throw new Error("Could not insert tasks into History Records");
      }

      // Show success toast notification
      toast.success("Tasks successfully copied to History Records.");
    } catch (error) {
      console.error(error.message);
      toast.error("Error during task reset: " + error.message);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <button
      className="reset-button"
      onClick={handleReset}
      disabled={isProcessing}
    >
      <DifferenceOutlinedIcon className="icon" />
      {isProcessing ? "Processing..." : "Save History"}
    </button>
  );
};

export default ResetHistoryButton;
